import MuiDivider, { type DividerProps } from '@mui/material/Divider';

export type { DividerProps };

const Divider = (props: DividerProps) => <MuiDivider {...props} />;

export default Divider;
